"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable max-len */
var react_1 = __importDefault(require("react"));
var MusicNoteQuaver = function (_a) {
    var size = _a.size, title = _a.title, color = _a.color, svgProps = __rest(_a, ["size", "title", "color"]);
    return (react_1.default.createElement("svg", __assign({ stroke: "currentcolor", fill: "currentColor", strokeWidth: "0" }, svgProps, { width: size || '1rem', height: size || '1rem', viewBox: "0 0 24 24", style: __assign({ color: color }, svgProps.style), xmlns: "http://www.w3.org/2000/svg" }),
        title && react_1.default.createElement("title", null, title),
        react_1.default.createElement("g", { id: "music-note-quaver" },
            react_1.default.createElement("path", { id: "Icon", d: "M14.3155 4.1578L14.7628 3.26337L14.3155 4.1578ZM17.5528 6.89445C18.0468 7.14144 18.6474 6.94122 18.8944 6.44724C19.1414 5.95326 18.9412 5.35259 18.4472 5.1056L17.5528 6.89445ZM12.1805 4.04492L13 4.61806V4.61806L12.1805 4.04492ZM12.8538 3.6288L12.7077 2.63954V2.63954L12.8538 3.6288ZM13 18V5.58888H11V18H13ZM13.8683 5.05223L17.5528 6.89445L18.4472 5.1056L14.7628 3.26337L13.8683 5.05223ZM13 5.58888C13 5.14076 13.001 4.87359 13.0184 4.68339C13.0359 4.49175 13.0606 4.53141 13 4.61806L11.3611 3.47178C11.1199 3.81656 11.0543 4.1996 11.0267 4.5011C10.999 4.80404 11 5.17978 11 5.58888H13ZM14.7628 3.26337C14.3968 3.08042 14.0612 2.91149 13.7779 2.80081C13.4958 2.69066 13.1239 2.57804 12.7077 2.63954L13 4.61806C12.8954 4.63352 12.8709 4.59372 13.0502 4.66374C13.2281 4.73323 13.4675 4.85182 13.8683 5.05223L14.7628 3.26337ZM13 4.61806V4.61806L12.7077 2.63954C12.1635 2.71995 11.6764 3.02097 11.3611 3.47178L13 4.61806ZM11 18C11 19.1046 10.1046 20 9 20V22C11.2091 22 13 20.2092 13 18H11ZM9 20C7.89543 20 7 19.1046 7 18H5C5 20.2092 6.79086 22 9 22V20ZM7 18C7 16.8955 7.89543 16 9 16V14C6.79086 14 5 15.7909 5 18H7ZM9 16C10.1046 16 11 16.8955 11 18H13C13 15.7909 11.2091 14 9 14V16Z" }))));
};
exports.default = MusicNoteQuaver;
